import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Home.css"; // Make sure this file exists

export default function Home() {
  const services = [
    {
      title: "Artificial Intelligence (AI) Solutions",
      description:
        "Unlock the potential of Artificial Intelligence to transform your business. Our AI solutions drive automation, enhance decision-making, and streamline operations. From machine learning models to AI-powered chatbots, we help businesses innovate and stay ahead of the competition.",
      image: "/images/ai.jpg",
    },
    {
      title: "Cloud Solutions",
      description:
        "Elevate your business with secure and scalable Cloud services. We provide end-to-end cloud solutions, including migration, infrastructure management, and optimization, ensuring agility and cost-efficiency in your operations.",
      image: "/images/cloud.jpg",
    },
    {
      title: "Cybersecurity Services",
      description:
        "Protect your business from evolving cyber threats with our comprehensive cybersecurity services. We offer risk assessments, threat monitoring, data encryption, and incident response to secure your digital assets.",
      image: "/images/cybersecurity.jpg",
    },
    {
      title: "Data & Analytics Services",
      description:
        "Transform raw data into actionable insights with our Data & Analytics services. We leverage advanced analytics and business intelligence tools to help you make data-driven decisions and improve performance.",
      image: "/images/data-analytics.jpg",
    },
    {
      title: "Digital Marketing Services",
      description:
        "Drive targeted traffic and grow your online presence with our digital marketing expertise. We specialize in SEO, PPC, social media marketing, and email campaigns that boost brand visibility and maximize ROI.",
      image: "/images/marketing.jpg",
    },
    {
      title: "Corporate Training Programs",
      description:
        "Empower your workforce with cutting-edge corporate training programs. Our tailored learning solutions in leadership, technology, and soft skills ensure enhanced productivity, employee growth, and business success.",
      image: "/images/training.jpg",
    },
    {
      title: "Digital Marketing & SEO",
      description:
        "Boost your website’s visibility and organic search rankings with our expert Digital Marketing & SEO services. We optimize your content, perform keyword analysis, and implement strategies that increase traffic.",
      image: "/images/seo.jpg",
    },
    {
      title: "IT/Software Development Services",
      description:
        "Innovate and scale with our custom IT and Software development services. We offer bespoke solutions across web, mobile, and enterprise applications—high-quality, scalable, and secure.",
      image: "/images/software-dev.jpg",
    },
    {
      title: "US IT Staffing",
      description:
        "Access top-tier IT talent with our US IT Staffing services. We connect you with skilled professionals for contract, permanent, and project-based roles—ensuring the perfect fit for your technical needs.",
      image: "/images/staffing.jpg",
    },
    {
      title: "RPO (Recruitment Process Outsourcing)",
      description:
        "Streamline your recruitment process with our RPO services. We manage your entire hiring lifecycle, from sourcing to onboarding, saving you time and securing top talent aligned with your goals.",
      image: "/images/rpo.jpg",
    },
    {
      title: "Domestic Recruitment",
      description:
        "Find the right talent locally with our Domestic Recruitment services. We identify and recruit candidates who fit your organizational culture and requirements, ensuring long-term success.",
      image: "/images/domestic.jpg",
    },
    {
      title: "Quality Engineering and Assurance",
      description:
        "Ensure the highest standards of quality with our Quality Engineering and Assurance services. We help you design, test, and implement robust solutions that meet expectations and industry standards.",
      image: "/images/quality.jpg",
    },
    {
      title: "H1 Filings and Transfers",
      description:
        "Simplify your H1B visa process with our expert filing and transfer services. We manage all legal paperwork and details, ensuring a smooth experience with timely approvals every step of the way.",
      image: "/images/h1b.jpg",
    },
  ];

  return (
    <section id="services" className="py-5 bg-light">
      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card h-100 border-0 shadow service-card">
                <img
                  src={service.image}
                  alt={service.title}
                  loading="lazy"
                  className="card-img-top"
                />
                <div className="card-body text-white d-flex flex-column">
                  <h5 className="card-title fw-bold">{service.title}</h5>
                  <p className="card-text flex-grow-1">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
